import StoryImageAsset from './StoryImageAsset'
import StoryDefaultAsset from './StoryDefaultAsset'
import StoryTextAsset from './StoryTextAsset'
import StoryVideoAsset from './StoryVideoAsset'
import StoryYTAsset from './StoryVideoAsset'

function AssetFactory(asset) {
  switch (asset.type) {
    case 'IMAGE':
      return <StoryImageAsset key={asset.id} asset={asset} />
    case 'VIDEO':
      return <StoryVideoAsset key={asset.id} asset={asset} />
    case 'YOUTUBE':
      return <StoryYTAsset key={asset.id} asset={asset} />
    case 'AUDIO':
      return null
      //return StoryAudioAsset(asset)
    case 'TEXT':
      return <StoryTextAsset key={asset.id} asset={asset} />
    case 'PDF':
      return null
      //return StoryPDFAsset(asset)
    default:
      return <StoryDefaultAsset key={asset.id} asset={asset} />
  }
}

export default AssetFactory
